module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-sandy-springs.json
// module id = 416
// module chunks = 252635422454166